import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.header`
  width: 100%;
  height: 80px;

  position: fixed;
  top: 0;

  border-bottom: 1px solid #ebedf3;

  z-index: 14;

  background-color: #fff;
`;

export const Menu = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  max-width: 1360px;
  width: 100%;
  height: 100%;

  margin: 0 auto;
  padding: 0 25px;
`;

export const MenuLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 100%;
  max-width: 100%;

  > button {
    display: flex;
    align-items: center;
    justify-content: center;

    z-index: 14;

    height: 40px;
    width: 40px;

    margin: 0 20px;

    transition: background-color 0.2s;

    &:hover {
      background-color: #f3f6f9;

      > svg {
        color: ${({ theme }) => shade(0.25, theme.colors.primary)};
      }
    }

    > svg {
      width: 29px;
      height: 29px;

      color: #ccc;

      transition: color 0.2s;
    }
  }

  > a > img {
    height: 65px;
    width: 65px;

    margin-right: 6rem;
    margin-left: 2rem;

    @media (max-width: 420px) {
      margin-right: auto;
      margin-left: 0;
    }
  }

  @media (max-width: 720px) {
    > form {
      display: none;
    }

    > img {
      margin-left: 1rem;
    }

    > button {
      width: 40px;
    }
  }
`;

export const MenuRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 100%;
  max-width: 100%;

  > div:nth-child(1) {
    background-color: ${({ theme }) => theme.colors.primary};

    transition: background-color 0.2s;

    &:hover {
      background-color: ${({ theme }) => shade(0.25, theme.colors.primary)};
    }
  }

  > div:nth-last-child(2) > button {
    width: 43px;
    height: 43px;

    padding: 10px;

    border-radius: 0.85rem;

    > svg {
      width: 23px;
      height: 23px;
    }
  }

  > button {
    background-color: #c9f7f5;

    color: #1bc5bd;

    border: 2px solid transparent;

    height: 33px;

    padding: 0 16px;

    transition: background-color 0.2s, color 0.2s;

    &:hover {
      background-color: ${shade(0.1, '#c9f7f5')};
      color: white;
    }
  }

  > button:nth-child(1) {
    margin-right: 0.5rem;
  }

  > a {
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 10px;

    transition: background-color 0.2s;

    border-radius: 0.85rem;

    &:hover {
      background-color: #f3f6f9;

      > svg {
        color: ${({ theme }) => shade(0.25, theme.colors.primary)};
      }
    }

    > svg {
      color: #ccc;

      transition: color 0.2s;
    }
  }
`;

export const CustomButton = styled.button`
  display: flex;
  align-items: center;

  width: 100%;
  height: 100%;

  color: #ccc;

  transition: color 0.2s;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};

    > svg {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  > svg {
    margin-right: 8px;

    color: #ccc;

    transition: color 0.2s;
  }
`;

export const UserName = styled.li`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  font-size: 16px !important;
  font-weight: 600;
  color: #181c32 !important;

  border-bottom: 1px solid #ebedf3;

  margin-bottom: 6px;

  &:hover {
    background-color: white !important;
  }
`;
